import React, { FC, ReactNode } from 'react'

interface Props {
  icon: string // TODO: Can we type this?
  children?: ReactNode
}

const Tag: FC<Props> = ({ icon, children }) => {
  return (
    <div className="tag bg-light-blue text-secondary py-1 px-2 mr-2">
      <div className="tag__inner d-flex">
        <span>
          <span className={`icon-${icon}`}></span>
        </span>
        <span className="pl-1">{children}</span>
      </div>
    </div>
  )
}

export default Tag
